import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../const'
import { REDUCER_NAME } from './const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const FIND_BY_CUSTOMER_ID_REQUEST = NS + 'FIND_BY_CUSTOMER_ID_REQUEST'
export const FIND_BY_CUSTOMER_ID_SUCCESS = NS + 'FIND_BY_CUSTOMER_ID_SUCCESS'
export const FIND_BY_CUSTOMER_ID_ERROR = NS + 'FIND_BY_CUSTOMER_ID_ERROR'
export const TOGGLE_ANAMNESIS = NS + 'TOGGLE_ANAMNESIS'
export const TOGGLE_INFO_LEGEND = NS + 'TOGGLE_INFO_LEGEND'



// WEBPACK FOOTER //
// ./src/modules/anamnesis/state/list/type.js